import AppointmentQuickSelection from './AppointmentQuickSelection'

export default AppointmentQuickSelection